import type { HTMLAttributeAnchorTarget, ReactNode } from 'react'
import { classes } from 'src/utils'

type Props = {
  children: ReactNode
  className?: string
  href: string
  target?: HTMLAttributeAnchorTarget | undefined
}

export function Anchor(props: Props) {
  return (
    <a
      href={props.href}
      target={props.target}
      rel={props.target === '_blank' ? 'noreferrer' : ''}
      className={classes(
        'text-blue-600 visited:text-purple-600',
        props.className,
      )}
    >
      {props.children}
    </a>
  )
}
